export default {
  'new-year-unavailable:btn': 'ОК',
  'new-year-unavailable:title': 'Сервис мереке күндері жұмыс істемейді',
  'new-year-unavailable:text': 'Балаға арналған Kaspi Gold шотын 3 қаңтарда, сағат 9:00 бастап аштыруға болады'
}
